import { useField } from "@unform/core";
import { useEffect, useRef, useState } from "react";

import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const Core = ({ name, value, icon, onChange, ...rest }) => {
  const theme = useTheme();

  const [active, setActive] = useState(false);

  const ref = useRef(null);

  const { fieldName, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: "checked",
    });
  }, [fieldName, registerField]);

  const handleChange = (e) => {
    setActive(e.target.checked);
    onChange(e);
  };

  useEffect(() => {
    setActive(value);
  }, [value]);

  return (
    <S.Container $active={active}>
      <S.Input
        name={name}
        ref={ref}
        $active={active}
        type="checkbox"
        checked={active}
        onChange={handleChange}
        {...rest}
      />
      <S.Slider>
        {icon && active && (
          <GetIcon
            size="xs"
            name="Check"
            color={theme.colors.primary.vividBlue}
          />
        )}
        {icon && !active && (
          <GetIcon
            size="xs"
            name="Check"
            color={theme.colors.primary.vividCerulean}
          />
        )}
      </S.Slider>
    </S.Container>
  );
};

export default Core;
